import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckAuthenticatedService } from './api-services/check-authenticated.service'

/**
 * 認証検証画面
 *
 * @export AuthComponent
 * @class AuthComponent
 */
@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthComponent implements OnInit {

  isEmployee: boolean = <boolean>false;

  /**
   *Creates an instance of AuthComponent.
   * @param {KYMW00Model} kymw00Model
   * @param {ActivatedRoute} route
   * @param {Router} router
   * @param {CheckAuthenticatedService} checkAuthenticatedService
   * @memberof AuthComponent
   */
  constructor(
    public kymw00Model: KYMW00Model,
    private route: ActivatedRoute,
    private router: Router,
    private checkAuthenticatedService: CheckAuthenticatedService,
    ) {}

  /**
   * 初期処理
   *
   * @memberof AuthComponent
   */
  public ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.isEmployee = params['employee'] ? true : false;
    });
    this.checkAuthenticatedService.execute((data: any) => {
      if (data.UserID === '**********') {
        // Okta初回認証のセッション破棄回避
        this.checkAuthenticatedService.execute((data: any) => {
          if (data.UserID == null || data.UserID == '' || data.UserID === '**********') {
            // 未認証
            this.router.navigate(['/kymw/1003']);
          } else {
            // 認証済
            // ログイン時のauth.guard.tsの処理のためuserIDを入れる
            this.kymw00Model.kymw1001Model.loginUserInfo.UserID = data.UserID;
            this.router.navigate(['/kymw/1002']);
          }
        });
      } else if (data.UserID == null || data.UserID == '') {
        // 未認証
        if (this.isEmployee) {
          // コープデリ認証
          this.router.navigate(['/kymw/1003']);
        } else {
          // URL直打ち、更新ボタン等
          this.router.navigate(['/login']);
        }
      } else {
        // 認証済
        // ログイン時のauth.guard.tsの処理のためuserIDを入れる
        this.kymw00Model.kymw1001Model.loginUserInfo.UserID = data.UserID;
        this.router.navigate(['/kymw/1002']);
      }
    });
  }

}
